import React from 'react';
import ReactDOM from 'react-dom';
import {Link, Redirect} from 'react-router-dom';
import Loader from './Loader';
import AppHeader2 from './AppHeader2';
import SearchItems2 from './SearchItems2';
import BottomMenu from './BottomMenu';
import SidebarPanel from './SidebarPanel';

class SearchItem extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            LOCATION: this.props.location.pathname,
            LOADING: true, 
            items: [],
            cartEMPTY: 'Y',
            search_text: props.match.params.search_text,
            CUSTOMER_DET: '',
            page: 1,
            displayLoadMore: ''
        };
    }

    fetchSearchPage(mode,search_text,page) {

        var id = localStorage.getItem('delCIRCLE');

        let customer = '';
        if(localStorage.getItem('userData'))
            customer = localStorage.getItem('userData');
       
        var that = this;
        fetch('https://m.donedelivery.in/api/search_api.php?mode='+mode+'&id='+id+'&search_text='+search_text+'&page='+page,{
            mode: 'cors',
            credentials: 'same-origin',
            headers: {
                'Access-Control-Allow-Origin': '*', 
                Accept: 'application/json', 
                'Content-Type': 'application/json',
            },
        }).then(function (response) {
            return response.json();
        }).then(function (result) {
            //console.log(result);
            var ITEMS = result.ITEMS;

            var ITEMCOUNT = result.ITEMCOUNT;
            var CUSTOMER_DET = 'Hi User';
            if(result.CUSTOMER!=='' && result.CUSTOMER!==undefined && result.CUSTOMER!=='undefined')
                CUSTOMER_DET = result.CUSTOMER;
            
            that.setState({ LOADING:false, items:ITEMS, CUSTOMER_DET:CUSTOMER_DET, page: result.page, displayLoadMore: result.LOADMORE });
        });
    }

    fetchSecond(mode,search_text,page) {
        var id = localStorage.getItem('delCIRCLE');

        let customer = '';
        if(localStorage.getItem('userData'))
            customer = localStorage.getItem('userData');
       
        var that = this;
        fetch('https://m.donedelivery.in/api/search_api.php?mode='+mode+'&id='+id+'&search_text='+search_text+'&page='+page,{
              mode: 'cors',
              credentials: 'same-origin',
              headers: {
                  'Access-Control-Allow-Origin': '*', 
                  Accept: 'application/json', 
                  'Content-Type': 'application/json',
              },
          }).then(function (response) {
            return response.json();
          }).then(function (result) {

            var ITEMCOUNT = result.ITEMCOUNT;
            var CUSTOMER_DET = 'Hi User';
            if(result.CUSTOMER!=='' && result.CUSTOMER!==undefined && result.CUSTOMER!=='undefined')
                CUSTOMER_DET = result.CUSTOMER;
            
            that.setState({ items: that.state.items.concat(result.ITEMS), page: result.page, displayLoadMore: result.LOADMORE});
        });
    }    
    
    inCartCallBack = () =>{

        let cartEMPTY = 'Y';
        let cart = localStorage.getItem('cartData');
        if(cart !== null && cart!=='{}')
            cartEMPTY = 'N';

        var that = this;
        that.setState({ cartEMPTY:cartEMPTY });
    }
    
    componentWillMount() {
        let mount = $("div").hasClass("modal-backdrop");
        if(mount==true)
        {
            $('body').removeClass('modal-open');
            $(".modal-backdrop").remove();
        }
    }

    componentWillReceiveProps(nextProps) {
        window.location.reload();
    }

    componentDidMount() {
        var search_text = this.state.search_text;
        if(search_text==undefined || search_text=='undefined')
            search_text = '';
        this.fetchSearchPage('SEARCH',search_text,this.state.page);
    }

    loadMore = () => {
        var search_text = this.state.search_text;
        if(search_text==undefined || search_text=='undefined')
            search_text = '';
        //this.state.loading = true;
        this.fetchSecond('SEARCH',search_text,this.state.page);
    };
  
    render() { 
        let AppHeaderClass = 'appHeader bg-dark text-light';
        let AppHeaderLeft = 'showLINK';
        let AppHeaderLeftLink = '/home';
        let AppHeaderTitle = 'Search Result';
        let AppHeaderRight = '';
        let AppHeaderRightLink = 'SEARCH';
        let AppHeaderSearch = ''; //this.state.VENDORNAME;

        let props = {
            items: this.state.items,
            inCartCallBack: this.inCartCallBack,
        };

        return (
            <div>
                {this.state.LOADING && <Loader />}
                {this.state.VENDORNAME!='' && <AppHeader2 AppHeaderClass={AppHeaderClass} AppHeaderLeft={AppHeaderLeft} AppHeaderLeftLink={AppHeaderLeftLink} AppHeaderTitle={AppHeaderTitle} AppHeaderRight={AppHeaderRight} AppHeaderRightLink={AppHeaderRightLink} AppHeaderSearch={AppHeaderSearch} />}
                <div id="appCapsule">
                    {this.state.items.length>0 && 
                        <div className="section pt-0 pb-2">
                            <div className="row">
                                <SearchItems2 {...props} />
                            </div>
                            {this.state.displayLoadMore=='Y' && <p>
                                <button type="button" style={{'height': '31px'}} onClick={() => this.loadMore()} className="btn newshadowed text-dgrey font-size-11 square btn-danger btn-llg btn-block goBack">Load More</button>
                            </p>}
                        </div>
                    }
                    {this.state.items.length==0 &&
                        <div className="section pt-6" style={{textAlign: 'center'}}>
                            <img src="/assets/img/no-records.png" alt="empty-cart" className="form-image imaged w200" />
                        </div>
                    }
                </div>
                <BottomMenu LOCATION={this.state.LOCATION} />
                {this.state.CUSTOMER_DET && <SidebarPanel CUSTOMER_DET={this.state.CUSTOMER_DET}/>}
            </div>
        );
    }
}
      
export default SearchItem;


// WEBPACK FOOTER //
// ./src/components/SearchItems.js